mainApp.directive('monitorItem', function() {
    return {
        templateUrl: '/public/directives/monitorItem.html',
        scope: {
            item: "=?",
            legend: "=?",
            rt: "=?",
            hidecurrents: "@",
            hideinfo: "@",
            showTicks: "@",
            innerSegmentsCount: "=",
            linkHealthEl: "@",
            currIndex: "=?"
        },
        controller: ["$scope", "$timeout", 'DevicesService', '$interval', 'GeneralUtilsService', '$element', function($scope, $timeout, DevicesService, $interval, GeneralUtilsService, $element) {
            $scope.numberOfLinks = 0;
            $scope.online = false;

            if($scope.item){
                for(var link in $scope.item.links){
                    if($scope.item.links[link].status === "up"){
                        $scope.online = true;
                    }
                } 
            }

            if($scope.hidecurrents){
                $scope.expandedLinks = true;
            }


            $scope.internetConnectivityType = DevicesService.getInternetConnectivityType();

            $scope.os = DevicesService.getOs();

            $scope.deviceCategory = DevicesService.getDeviceCategories();

            $scope.protocol = DevicesService.getProtocols();

            $scope.icons = DevicesService.getDevicesIcons();
            $scope.type = $scope.item? ($scope.item.login? "login" : "site") : "";

            if($scope.type === "site"){
                $scope.iconType = $scope.type + $scope.item.site.siteType;
            }
            else {
                $scope.iconType = $scope.type;
            }

            $scope.$watch('item', function(){
                if(!$scope.item.links){
                    $scope.numberOfLinks = 0;
                    $scope.online = false;
                }
                else {

                    var count = 0;
                    for(var link in $scope.item.links){
                        if(link !== "mergedLink"){
                            count++;
                        }
                        if($scope.item.links[link].status === "up"){
                            $scope.online = true;
                        }
                    }

                    $scope.numberOfLinks = count;

                    $timeout(function(){
                        $scope.linkWidth = $('#link-health-'  + $scope.item.pid + '-merged').width();
                        $scope.ready = true;
                    }, 10);
                }
            });


            /*$scope.toggleMore = function(e, index){
                e.stopPropagation();
                var $middleEl = $('#link-stats-wrapper-' + index);
                if($middleEl.hasClass('open')){
                    $middleEl.removeClass('open');
                    e.target.textContent = 'Show More';
                }
                else {
                    $middleEl.addClass('open');
                    e.target.textContent = 'Show Less';
                }
            };*/

            $scope.legendClick = function(e, index, linkId, type){
                if($scope.legend){
                    $scope.legend(e, index, linkId, type);
                }
            };

            $scope.legendEnter = function(e, index, linkId, type){

            };

            $scope.legendLeave = function(e, index, linkId, type){

            };

            $scope.toggleExpandedLinks = function(){
                $scope.expandedLinks = !$scope.expandedLinks;

                $timeout(function(){
                    $scope.linkWidth = $('#link-health-'  + $scope.item.pid + '-merged').width();
                }, 1);
            };

            $scope.getCurrentStat = function(type){
                if(!$scope.item.links || Object.keys($scope.item.links).length === 0){
                    return 0;
                }

                var res = 0;
                for(var linkID in $scope.item.links){
                    if(linkID !== "mergedLink"){
                        var link = $scope.item.links[linkID];
                        if(link[type] && !link.displayOff && link.status === "up"){
                            res += link[type];
                        }
                    }
                }

                return res;
            };


            $scope.$on('$destroy', () => {
                GeneralUtilsService.cleanAmChartsFromScope($element);
            });
        }]
    }
});